//whiteboard constants

export const PAGE_LIMIT = 10

export const THROTTLE_PERIOD = 4000

export const DEBOUNCE_PERIOD = 1000

export const MAX_PAGE_REACHED_MESSAGE = 'oh. page limit reached'

export const SUBSCRIBE_TO_ALL = 'subscribe_to_all'
